import {
  GET_CLUB_SIGNUP_SUCCESS,
  GET_CLUB_SIGNUP_REQUESTING,
  RESET_CLUB_SIGNUP_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CLUB_SIGNUP_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case GET_CLUB_SIGNUP_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_CLUB_SIGNUP_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
